import "../node_modules/leaflet/dist/leaflet.css";
import L from "leaflet";
import { validatIp, addTileLayer, addOffset } from "./helpers";
import icon from "../images/icon-location.svg";

const GEO_URL =
  "https://geo.ipify.org/api/v2/country,city?apiKey=at_hYs5BucFXDWsMFzaSNcNMGZQQoC7b&ipAddress=";

const input = document.querySelector(".search-bar__input");
const btn = document.querySelector(".search-bar__btn");

const ipInfo = document.querySelector("#ip");
const locationInfo = document.querySelector("#location");
const timezoneInfo = document.querySelector("#timezone");
const ispInfo = document.querySelector("#isp");

const mapContent = document.querySelector(".map");
const map = L.map(mapContent).setView([51.505, -0.09], 13);

const markerIcon = L.icon({
  iconUrl: icon,
  iconSize: [25, 30],
});

addTileLayer(map);
L.marker([51.505, -0.09], { icon: markerIcon }).addTo(map);

input.addEventListener("keydown", handleKey);
btn.addEventListener("click", handleClick);

function handleKey(event) {
  if (event.key === "Enter") {
    getGeo(input.value);
  }
}

function handleClick() {
  getGeo(input.value);
}

async function getGeo(ip = "110.10.10.1") {
  if (validatIp(ip)) {
    const response = await fetch(GEO_URL + ip);
    setData(await response.json());
  }
}

function setData(data) {
  console.log(data);
  const {
    ip,
    isp,
    location: { city, country, lat, lng, timezone },
  } = data;
  ipInfo.innerText = ip;
  locationInfo.innerText = city + "," + country;
  timezoneInfo.innerText = timezone;
  ispInfo.innerText = isp;

  map.setView([lat, lng]);
  L.marker([lat, lng], { icon: markerIcon }).addTo(map);

  if (matchMedia("(max-width: 1023px)").matches) {
    addOffset(map);
  }
  clearInput();
}

function clearInput() {
  input.value = "";
}

document.addEventListener("DOMContentLoaded", () => {
  getGeo("110.10.10.1");
});
